export const routemap = [
    {path:"/public", gaurded:false }
];

export default routemap;